export default "__VITE_ASSET__DALm0P48__"